import EditJobForm from "../components/Form/EditJobForm";

const EditJob = () => {
    return (
        <>
            <h1 className="mb-10 text-center lws-section-title">Edit Job</h1>

            <div className="max-w-3xl mx-auto">
                <EditJobForm />
            </div>
        </>
    );
};

export default EditJob;
